import React, { useState } from "react";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function CRMLeads() {

  const [prospects] = useState([

    {
      name: "Vasanth Raju",
      phone: "+91 9876543210",
      source: "Direct"
    },

    {
      name: "Anil Kumar",
      phone: "+91 9988776655",
      source: "Referral"
    }

  ]);


  const [siteVisits] = useState([

    {
      name: "Mohan Das",
      interest: "Plot F412 in interest",
      partner: "Channel partner"
    }

  ]);


  const [negotiations] = useState([

    {
      name: "Sunita Reddy",
      deal: "Plot Q330 • price agreed",
      type: "Referral"
    }

  ]);


  const [referrals] = useState([

    {
      referredBy: "Ramesh Kumar",
      referee: "Anil Sharma",
      mobile: "+91 9876543210",
      project: "JF Bagalur",
      status: "Contacted",
      bonus: "—"
    },

    {
      referredBy: "Kavitha Rao",
      referee: "Deepa Rao",
      mobile: "+91 9988771122",
      project: "JF Bagalur",
      status: "Converted",
      bonus: "₹15,000"
    }

  ]);


  return (

    <div>

      <Navbar />

      <Sidebar />

      <div className="admin-content">

        <div className="crm-container">

          {/* HEADER */}

          <div className="crm-header">

            <h1 style={{ marginTop: 0, marginBottom: 0 }}>
              CRM • lead pipeline
            </h1>

            <button className="add-lead-btn">
              + Add lead
            </button>

          </div>


          {/* LEAD BOARDS */}

          <div className="crm-board-grid">

            {/* PROSPECT */}

            <div className="crm-column">

              <div className="crm-column-header">

                <h3>
                  Prospect
                </h3>

                <span>8</span>

              </div>


              {
                prospects.map((lead, index) => (

                  <div
                    key={index}
                    className="lead-card"
                  >

                    <h4>
                      {lead.name}
                    </h4>

                    <p>
                      {lead.phone}
                    </p>

                    <span className="lead-tag">
                      {lead.source}
                    </span>

                  </div>

                ))
              }

            </div>


            {/* SITE VISIT */}

            <div className="crm-column">

              <div className="crm-column-header">

                <h3>
                  Site visit done
                </h3>

                <span>5</span>

              </div>


              {
                siteVisits.map((lead, index) => (

                  <div
                    key={index}
                    className="lead-card"
                  >

                    <h4>
                      {lead.name}
                    </h4>

                    <p>
                      {lead.interest}
                    </p>

                    <span className="lead-tag">
                      {lead.partner}
                    </span>

                  </div>

                ))
              }

            </div>


            {/* NEGOTIATION */}

            <div className="crm-column">

              <div className="crm-column-header">

                <h3>
                  Negotiation
                </h3>

                <span>3</span>

              </div>


              {
                negotiations.map((lead, index) => (

                  <div
                    key={index}
                    className="lead-card"
                  >

                    <h4>
                      {lead.name}
                    </h4>

                    <p>
                      {lead.deal}
                    </p>

                    <span className="lead-tag">
                      {lead.type}
                    </span>

                  </div>

                ))
              }

            </div>

          </div>


          {/* REFERRAL TABLE */}

          <div className="referral-section">

            <h2>
              REFERRALS
            </h2>


            <div className="crm-table-wrapper">

              <table className="crm-table">

                <thead>

                  <tr>

                    <th>Referred by</th>

                    <th>Referee name</th>

                    <th>Mobile</th>

                    <th>Project interest</th>

                    <th>Status</th>

                    <th>Bonus</th>

                  </tr>

                </thead>


                <tbody>

                  {
                    referrals.map((item, index) => (

                      <tr key={index}>

                        <td>
                          {item.referredBy}
                        </td>

                        <td>
                          {item.referee}
                        </td>

                        <td>
                          {item.mobile}
                        </td>

                        <td>
                          {item.project}
                        </td>

                        <td>

                          <span
                            className={`status-badge ${
                              item.status === "Converted"
                                ? "green"
                                : "orange"
                            }`}
                          >

                            {item.status}

                          </span>

                        </td>

                        <td>
                          {item.bonus}
                        </td>

                      </tr>

                    ))
                  }

                </tbody>

              </table>

            </div>

          </div>

        </div>

      </div>

    </div>

  );

}

export default CRMLeads;